import React from 'react';

import { Button, FontAwesomeIcon } from '@schoolinks/ui-components';
import cn from 'classnames';
import { isEmpty } from 'lodash';

import { bool, func, string } from 'prop-types';

import { faCircleQuestion } from '@fortawesome/pro-solid-svg-icons/faCircleQuestion';

import useLocalStorage from 'hooks/useLocalStorage';

import s from './HowToUseThisFeatureButton.css';

const DEFAULT_BUTTON_LABEL = 'How to use this feature';

const HowToUseThisFeatureButton = ({
  buttonLabel,
  moduleHasFeatureOnboarding,
  featureOnboardingModalOpen,
  setFeatureOnboardingModalOpen,
}) => {
  const [showAccessibilityWidget] = useLocalStorage(
    'showAccessibilityWidget',
    false,
  );
  return moduleHasFeatureOnboarding ? (
    <Button
      onClick={() => setFeatureOnboardingModalOpen(!featureOnboardingModalOpen)}
      className={cn(s.helpButton, {
        [s.withAccessibilityWidget]: showAccessibilityWidget,
      })}
      color="primary"
      variant="filled"
      hasIconRight
      icon={<FontAwesomeIcon icon={faCircleQuestion} />}
      label={!isEmpty(buttonLabel) ? buttonLabel : DEFAULT_BUTTON_LABEL}
    />
  ) : null;
};

HowToUseThisFeatureButton.propTypes = {
  buttonLabel: string,
  moduleHasFeatureOnboarding: bool.isRequired,
  featureOnboardingModalOpen: bool.isRequired,
  setFeatureOnboardingModalOpen: func.isRequired,
};

HowToUseThisFeatureButton.defaultProps = {
  buttonLabel: DEFAULT_BUTTON_LABEL,
};

export default HowToUseThisFeatureButton;
